var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_cof.js
 ** module id = 195
 ** module chunks = 0
 **/